/* eslint-disable no-console */
import { register } from 'register-service-worker'
import { EventBus } from '@/helpers'

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'stage') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    scope: './',
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (reg) {
      console.log('Service worker has been registered.', reg)
      setInterval(() => {
        reg.update()
      }, 1000 * 60 * 15) // e.g. 15 minutes
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
      // window.location.reload()
    },
    updated (reg) {
      console.log('New content is available please refresh.', reg)
      EventBus.$emit('app::new-version-available', reg)
    },
    offline () {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
